<div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card-box">
                <div v-if="!loading">
                    <data-table :headings="attendantsHeadings" :data="attendants" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @actionClicked="onAttendantActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100">
                                <button class="btn btn-primary" @click="onAddAttendantClick">Add Attendant</button>
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.searchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <active-inactive-radio-buttons :activeInactiveKey="filter.activeOrInactiveItems"
                                                               :componentId="'attendantsFilterRadioButtons'"
                                                               @activeInactiveSelected="onActiveInactiveFilterSelected"></active-inactive-radio-buttons>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
    </div>

    <!-- Mark as Active/Inactive Modal -->
    <mark-as-active-inactive-modal
                :heading="attendantMarkAsActiveInactiveModal.heading"
                :modalId="attendantMarkAsActiveInactiveModal.modalId"
                :isSaving="attendantMarkAsActiveInactiveModal.isSaving"
                :showModal="attendantMarkAsActiveInactiveModal.showModal"
                :isActive="attendantMarkAsActiveInactiveModal.isActive"
                @closeClicked="attendantMarkAsActiveInactiveModal.showModal = false"
                @saveButtonClicked="onMarkAsActiveInactiveSaveClick"></mark-as-active-inactive-modal>
    
    <!-- Add/Edit Attendant Modal -->
    <modal-form
            :heading="attendantAddEditFormModal.heading"
            :modalId="attendantAddEditFormModal.modalId"
            :isSaving="attendantAddEditFormModal.isSaving"
            :showModal="attendantAddEditFormModal.showModal"
            @closeClicked="onAddOrEditAttendantModalCloseClick"
            @saveButtonClicked="onAddOrEditAttendantSaveClick">
        <template #form>
            <form>
                <div class="form-group">
                    <label for="firstNameInput">
                        First Name
                    </label>
                    <div class="text-danger" v-if="attendantAddEditFormModal.attendant.firstName.hasError">
                        {{attendantAddEditFormModal.attendant.firstName.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="firstNameInput" v-model="attendantAddEditFormModal.attendant.firstName.value"/>
                </div>
                <div class="form-group">
                    <label for="lastNameInput">
                        Last Name
                    </label>
                    <div class="text-danger" v-if="attendantAddEditFormModal.attendant.lastName.hasError">
                        {{attendantAddEditFormModal.attendant.lastName.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="lastNameInput" v-model="attendantAddEditFormModal.attendant.lastName.value"/>
                </div>
                <div class="form-group">
                    <label for="attendantNumberInput">
                        Attendant Number
                    </label>
                    <div class="text-danger" v-if="attendantAddEditFormModal.attendant.attendantNumber.hasError">
                        {{attendantAddEditFormModal.attendant.attendantNumber.errorMessage}}
                    </div>
                    <input type="text" class="form-control" id="attendantNumberInput" v-model="attendantAddEditFormModal.attendant.attendantNumber.value"/>
                </div>
            </form>
        </template>
    </modal-form>

    <!-- Transfer Attendant Modal -->
    <modal-form
            :heading="transferAttendantModal.heading"
            :modalId="transferAttendantModal.modalId"
            :isSaving="transferAttendantModal.isSaving"
            :showModal="transferAttendantModal.showModal"
            :saveButtonText="'Transfer'"
            @closeClicked="onTransferAttendantModalCloseClick"
            @saveButtonClicked="onTransferAttendantSaveClick">
        <template #form>
            <form>
                <div class="row">
                    <div class="col-6">
                        <div class="form-group">
                            <label for="attendantNameInput">
                                Name
                            </label>
                            <input type="text" class="form-control" id="attendantNameInput" v-model="transferAttendantModal.attendantName" readonly/>
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-group">
                            <label for="attendantNumberTransferInput">
                                Attendant Number
                            </label>
                            <input type="text" class="form-control" id="attendantNumberTransferInput" v-model="transferAttendantModal.attendantNumber" readonly/>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="depotSelect">
                        Transfer to Depot <span class="text-danger">*</span>
                    </label>
                    <div class="text-danger" v-if="transferAttendantModal.newDepotId.hasError">
                        {{transferAttendantModal.newDepotId.errorMessage}}
                    </div>
                    <bootstrap-select :selectOptions="depots" :selectedOption="transferAttendantModal.newDepotId.value" :elementId="'depotSelect'"
                                       :returnSelectedOptionText="true"
                                       @changeSelect="onDepotSelected"></bootstrap-select>
                </div>
            </form>
        </template>
    </modal-form>
</div>
